import { createFileRoute } from "@tanstack/react-router";
import TeenDiagnosedDepression from "@/pages/articles/TeenDiagnosedDepression";
export const Route = createFileRoute(
  "/diagnosed-with-depression-as-a-teenager",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Diagnosed With Depression As A Teenager | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression in teenagers is real and treatable. Learn about treatment options, warning signs, and how to support a teen in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Diagnosed With Depression As A Teenager | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression in teenagers is real and treatable. Learn about treatment options, warning signs, and how to support a teen in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/diagnosed-with-depression-as-a-teenager",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/diagnosed-with-depression-as-a-teenager",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TeenDiagnosedDepression />;
}
